import axios from "axios";

const baseUrl = "https://api-prod-1.gymbook.in/api";

export const markAttendance = async (mobile, subID) => {
  try {
    const response = await axios.put(`${baseUrl}/member/puchinout/auto`, {
      mobile,
      subID,
    });
    return response.data;
  } catch (err) {
    console.error("Failed to mark attendance", err);
    throw err;
  }
};

export const getGymDetails = async (subID) => {
  try {
    const response = await axios.get(
      `${baseUrl}/subscriber/member-app?subID=${subID}`
    );
    return response.data.data;
  } catch (error) {
    console.error("Failed to fetch gym details", error);
    throw error;
  }
};
